:root {
  color: #16202a;
  background: #f4f7f9;
  font-family:
    Inter,
    ui-sans-serif,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  min-width: 320px;
  min-height: 100vh;
  background: #f4f7f9;
}

button,
input,
select,
textarea {
  font: inherit;
}

a {
  color: #075a9c;
}

a:focus-visible,
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible,
[tabindex]:focus-visible {
  outline: 3px solid #f5a623;
  outline-offset: 3px;
}

.skip-link {
  position: fixed;
  top: 0.5rem;
  left: 0.5rem;
  z-index: 100;
  transform: translateY(-200%);
  padding: 0.75rem 1rem;
  background: #ffffff;
  color: #111111;
  border: 2px solid #111111;
}

.skip-link:focus {
  transform: translateY(0);
}

.site-header {
  color: #ffffff;
  background: #123b5d;
}

.site-header__inner {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  max-width: 76rem;
  margin: 0 auto;
  padding: 1.6rem 1.25rem 1.2rem;
}

.site-header h1 {
  margin: 0;
  font-size: clamp(1.65rem, 4vw, 2.5rem);
}

.eyebrow {
  margin: 0 0 0.4rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.site-description {
  max-width: 48rem;
  margin-bottom: 0;
  line-height: 1.55;
}

.header-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.55rem;
}

.phase-badge,
.account-label {
  display: inline-flex;
  align-items: center;
  min-height: 2rem;
  white-space: nowrap;
  padding: 0.4rem 0.75rem;
  border: 1px solid #b9d9f2;
  border-radius: 999px;
  background: #ffffff;
  color: #123b5d;
  font-weight: 700;
}

.account-label {
  border-color: rgb(255 255 255 / 45%);
  background: rgb(0 0 0 / 12%);
  color: #ffffff;
  font-weight: 600;
}

.header-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}

.header-actions button {
  border: 1px solid rgb(255 255 255 / 70%);
  background: transparent;
}

nav {
  border-top: 1px solid rgb(255 255 255 / 25%);
  background: #0d304c;
}

.nav-list {
  display: flex;
  flex-wrap: wrap;
  max-width: 76rem;
  margin: 0 auto;
  padding: 0 1rem;
  list-style: none;
}

.nav-list a {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  padding: 0.65rem 0.75rem;
  color: #ffffff;
  font-weight: 650;
  text-decoration: none;
}

.nav-list a:hover,
.nav-list a[aria-current='page'] {
  background: rgb(255 255 255 / 12%);
  text-decoration: underline;
}

main {
  width: min(76rem, calc(100% - 2rem));
  margin: 2rem auto;
}

.panel {
  margin-bottom: 1.25rem;
  padding: clamp(1rem, 3vw, 1.5rem);
  border: 1px solid #c7d2dc;
  border-radius: 0.75rem;
  background: #ffffff;
  box-shadow: 0 0.25rem 1rem rgb(18 59 93 / 8%);
}

.panel h2,
.panel h3 {
  margin-top: 0;
}

.panel > :last-child {
  margin-bottom: 0;
}

.auth-layout {
  display: grid;
  min-height: 70vh;
  place-items: center;
}

.auth-card {
  width: min(32rem, 100%);
}

.auth-card h2 {
  margin-bottom: 0.4rem;
}

.lead {
  margin-top: 0;
  color: #445566;
  line-height: 1.55;
}

.form-grid {
  display: grid;
  gap: 1rem;
}

.form-grid--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.form-field {
  display: grid;
  gap: 0.35rem;
}

.form-field label,
.field-label,
legend {
  font-weight: 700;
}

.form-field input,
.form-field select,
.form-field textarea,
.input {
  width: 100%;
  min-height: 44px;
  padding: 0.65rem 0.75rem;
  border: 1px solid #8294a5;
  border-radius: 0.4rem;
  background: #ffffff;
  color: #16202a;
}

.form-field textarea {
  min-height: 7rem;
  resize: vertical;
}

.help-text {
  margin: 0;
  color: #526474;
  font-size: 0.92rem;
  line-height: 1.45;
}

.checkbox-field {
  display: flex;
  gap: 0.6rem;
  align-items: flex-start;
}

.checkbox-field input {
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 0.15rem;
}

fieldset {
  min-width: 0;
  margin: 0;
  padding: 1rem;
  border: 1px solid #c7d2dc;
  border-radius: 0.55rem;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}

.actions--end {
  justify-content: flex-end;
}

button,
.button {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  padding: 0.65rem 1rem;
  border: 0;
  border-radius: 0.4rem;
  background: #075a9c;
  color: #ffffff;
  font: inherit;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
}

button:hover,
.button:hover {
  background: #064878;
}

button:disabled,
.button[aria-disabled='true'] {
  cursor: not-allowed;
  opacity: 0.55;
}

.button--secondary,
button.secondary {
  border: 1px solid #075a9c;
  background: #ffffff;
  color: #075a9c;
}

.button--secondary:hover,
button.secondary:hover {
  background: #eef5fa;
}

.button--danger,
button.danger {
  background: #a62424;
}

.button--danger:hover,
button.danger:hover {
  background: #841d1d;
}

.button--plain,
button.plain {
  min-height: auto;
  padding: 0;
  background: transparent;
  color: #075a9c;
  text-decoration: underline;
}

.status-row {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

.status-content > :first-child {
  margin-top: 0;
}

.status-content > :last-child {
  margin-bottom: 0;
}

.status-indicator {
  width: 0.85rem;
  height: 0.85rem;
  flex: 0 0 auto;
  margin-top: 0.3rem;
  border-radius: 50%;
  background: #237a3b;
}

.status-indicator--warning {
  background: #a66c00;
}

.status-indicator--neutral {
  background: #63788b;
}

.definition-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(13rem, 1fr));
  gap: 1rem;
  margin: 0;
}

.definition-grid div {
  padding: 0.9rem;
  border-left: 4px solid #2b6f9f;
  background: #eef5fa;
}

.definition-grid dt {
  font-weight: 750;
}

.definition-grid dd {
  margin: 0.25rem 0 0;
  overflow-wrap: anywhere;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  gap: 1rem;
}

.card {
  padding: 1rem;
  border: 1px solid #c7d2dc;
  border-radius: 0.65rem;
  background: #ffffff;
}

.card h3 {
  margin: 0 0 0.5rem;
}

.card p {
  line-height: 1.5;
}

.card--selected {
  border: 2px solid #075a9c;
  box-shadow: 0 0 0 2px rgb(7 90 156 / 10%);
}

.alert {
  display: grid;
  gap: 0.3rem;
  margin: 0 0 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid;
  border-left-width: 5px;
  border-radius: 0.45rem;
  line-height: 1.45;
}

.alert > div > :first-child {
  margin-top: 0;
}

.alert > div > :last-child {
  margin-bottom: 0;
}

.alert--error {
  border-color: #b62b2b;
  background: #fff1f1;
  color: #611515;
}

.alert--success {
  border-color: #2c7a42;
  background: #edf8f0;
  color: #174d29;
}

.alert--warning {
  border-color: #a66c00;
  background: #fff8e5;
  color: #654300;
}

.alert--info {
  border-color: #2b6f9f;
  background: #eef5fa;
  color: #153f5e;
}

.loading-panel {
  display: flex;
  gap: 0.8rem;
  align-items: center;
}

.loading-panel p {
  margin: 0;
}

.spinner {
  width: 1.25rem;
  height: 1.25rem;
  border: 3px solid #c7d2dc;
  border-top-color: #075a9c;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.table-wrap {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 0.75rem;
  border-bottom: 1px solid #d7e0e7;
  text-align: left;
  vertical-align: top;
}

th {
  background: #eef5fa;
  color: #203747;
}

code,
.code-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  overflow-wrap: anywhere;
}

.code-block {
  padding: 0.85rem;
  border: 1px solid #c7d2dc;
  border-radius: 0.4rem;
  background: #f6f8fa;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.recovery-codes {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
  gap: 0.5rem;
  padding: 0;
  list-style: none;
}

.recovery-codes li {
  padding: 0.65rem;
  border: 1px solid #c7d2dc;
  border-radius: 0.35rem;
  background: #f6f8fa;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  text-align: center;
}

.permission-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  gap: 0.55rem 1rem;
}

.permission-grid label {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
}

.badge {
  display: inline-flex;
  align-items: center;
  min-height: 1.7rem;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  background: #e3edf5;
  color: #1d4b6b;
  font-size: 0.85rem;
  font-weight: 700;
}

.badge--success {
  background: #dff2e4;
  color: #225d32;
}

.badge--warning {
  background: #fff0c7;
  color: #6a4900;
}

.badge--danger {
  background: #f8dddd;
  color: #792020;
}

.support-banner {
  margin: -0.75rem 0 1.25rem;
  padding: 0.9rem 1rem;
  border: 2px solid #8b5f00;
  border-radius: 0.55rem;
  background: #fff8e5;
}

.update-panel {
  border-color: #8b5f00;
  background: #fff8e5;
}

footer {
  padding: 1.5rem 1rem 2rem;
  color: #34495a;
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 48rem) {
  .site-header__inner {
    flex-direction: column;
    gap: 1rem;
  }

  .header-meta {
    align-items: flex-start;
  }

  .header-actions {
    justify-content: flex-start;
  }

  .form-grid--two {
    grid-template-columns: 1fr;
  }

  .nav-list {
    overflow-x: auto;
    flex-wrap: nowrap;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

.template-folder-grid > button {
  width: 100%;
  min-height: 3.25rem;
  justify-content: flex-start;
  text-align: left;
}

.template-folder-grid > button,
.template-control-card select,
.template-folder-grid > button,
.template-control-card select {
  padding-block: 0.65rem;
}

.template-folder-grid > button,
.template-control-card input,
.template-control-card select,
.template-folder-grid > button,
.template-folder-grid > button {
  justify-content: flex-start;
  text-align: left;
  padding-inline: 1rem;
}

.template-control-card input,
.template-control-card select {
  padding-block: 0;
  padding-inline: 1rem;
}

.forms-explorer-layout {
  display: grid;
  grid-template-columns: minmax(28rem, 1.45fr) minmax(20rem, 0.8fr);
  gap: 1rem;
  align-items: stretch;
}

.forms-folders-card {
  display: flex;
  flex-direction: column;
  min-height: 34rem;
}

.form-folder-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
  gap: 0.75rem;
  align-content: start;
  margin-top: 0.5rem;
  padding-right: 0.25rem;
  max-height: 20rem;
  overflow: auto;
}

.form-folder-grid > button,
.form-control-card input,
.form-control-card select,
.form-folder-create-form input,
.form-control-submit {
  width: 100%;
  height: 3.25rem;
  min-height: 3.25rem;
  max-height: 3.25rem;
  box-sizing: border-box;
}

.form-folder-grid > button,
.form-control-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-block: 0;
  padding-inline: 1rem;
}

.form-folder-grid > button {
  justify-content: flex-start;
  gap: 0.7rem;
  text-align: left;
}

.form-folder-icon {
  width: 1.5rem;
  height: 1.5rem;
  flex: 0 0 1.5rem;
}

.form-folder-grid > button > span {
  min-width: 0;
}

.form-folder-create-form {
  margin-top: auto;
  padding-top: 1rem;
  border-top: 1px solid var(--border);
}

.form-folder-create-row {
  display: grid;
  grid-template-columns: minmax(12rem, 1fr) minmax(11rem, 0.7fr);
  gap: 0.75rem;
  align-items: end;
}

.form-control-card {
  align-content: start;
}

.form-control-card input,
.form-control-card select,
.form-folder-create-form input {
  padding-block: 0;
  padding-inline: 1rem;
}

@media (max-width: 900px) {
  .forms-explorer-layout {
    grid-template-columns: 1fr;
  }

  .form-folder-create-row {
    grid-template-columns: 1fr;
  }
}

.reference-data-layout {
  display: grid;
  grid-template-columns: minmax(18rem, 0.8fr) minmax(28rem, 1.4fr);
  gap: 1rem;
  align-items: start;
  margin: 1rem 0 1.5rem;
}

.reference-list-card,
.reference-version-card {
  min-width: 0;
}

.reference-list-grid {
  display: grid;
  gap: 0.6rem;
  max-height: 20rem;
  overflow: auto;
  margin-bottom: 1rem;
  padding-right: 0.2rem;
}

.reference-list-button {
  width: 100%;
  min-height: 3.25rem;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.15rem;
  text-align: left;
}

.reference-list-button small {
  font-weight: 500;
}

.reference-list-button[aria-pressed='true'] {
  border-width: 2px;
  background: #eef5fa;
}

.reference-create-form,
.reference-item-editor,
.reference-import-form,
.reference-mapping-form {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #c7d2dc;
}

.reference-item-fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
}

.reference-section-heading {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: start;
  margin-top: 1.5rem;
}

.reference-section-heading h3,
.reference-section-heading p {
  margin-top: 0;
}

.reference-import-preview {
  margin-top: 1.5rem;
}

.reference-import-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 1rem 0;
}

.reference-import-counts span {
  padding: 0.4rem 0.65rem;
  border-radius: 999px;
  background: #e3edf5;
  color: #1d4b6b;
  font-weight: 700;
}

@media (max-width: 900px) {
  .reference-data-layout,
  .reference-item-fields {
    grid-template-columns: 1fr;
  }

  .reference-section-heading {
    flex-direction: column;
  }
}
